var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3438 8.50017L13.9848 4.85917C14.2537 4.5902 14.2537 4.15546 13.9848 3.88649C13.7158 3.61753 13.281 3.61753 13.0121 3.88649L9.37107 7.5275L5.73007 3.88649C5.4611 3.61753 5.02635 3.61753 4.75739 3.88649C4.48842 4.15546 4.48842 4.5902 4.75739 4.85917L8.3984 8.50017L4.75739 12.1412C4.48842 12.4101 4.48842 12.8449 4.75739 13.1139C4.89153 13.248 5.06763 13.3154 5.24373 13.3154C5.41983 13.3154 5.59593 13.248 5.73007 13.1139L9.37107 9.47285L13.0121 13.1139C13.1462 13.248 13.3223 13.3154 13.4984 13.3154C13.6745 13.3154 13.8506 13.248 13.9848 13.1139C14.2537 12.8449 14.2537 12.4101 13.9848 12.1412L10.3438 8.50017Z",
    fill: "#252421"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9ae256475e090e9249835e430dd6db9b.svg";
export { ForwardRef as ReactComponent };